import styled from 'styled-components'

export const CheckButton = styled.button`
  border-radius: 0.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  min-width: 6rem;
  transform-origin: center;
  transition: background-color 50ms, color 50ms, transform 50ms;
  padding: 1.1rem 2rem;
  will-change: background-color, color, transform;

  &.default {
    background-color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.lightGray};
    color: ${({ theme }) => theme.colors.primary};

    &:hover {
      background-color: ${({ theme }) => theme.colors.white.darken(0.6)};
    }
  }

  &.checked {
    background-color: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary.darken(0.6)};
      border: 2px solid ${({ theme }) => theme.colors.primary.darken(0.6)};
    }
  }

  &:active {
    transform: scale(0.88);
  }
`
